import React from 'react';
import Menu from './menu';
import SearchDiscover from './searchdiscover';
import Logo from '../logo';
import translate from '../../../utils/translate';
import MenuItem from './menuitem';
import HeaderActions from '../../../actions/header';
import SlidingPanel from '../../common/slidingPanel';
import CollapsibleList from '../../common/collapsibleList';

export default class HeaderMobile extends React.Component {
  static propTypes = {
    logo: React.PropTypes.object,
    language: React.PropTypes.object
  };

  state = {
    isMenuOpen: false,
    tabWidth:   false,
    language:    false
  };

  toggleMenuOpen = () => {
    this.setState({
      isMenuOpen: !this.state.isMenuOpen,
      tabWidth:   this.state.isMenuOpen ? false : this.refs['mobileBtn'].getBoundingClientRect().width
    });
  };

  renderMenuButton = () => {
    const style = { width: this.state.tabWidth };
    let content;

    if (this.state.isMenuOpen) {
      content = <i className="mobilemenu__close" />;
    }
    else {
      content  = [<i key={0} className="mobilemenu__open" />];
    }

    let btnClassName = 'mobilemenu__toggle';
    btnClassName += this.state.isMenuOpen ? ' is-open' : '';

    return (
      <button
        ref="mobileBtn"
        className={btnClassName}
        onClick={this.toggleMenuOpen}
        style={style}>
        {content}
      </button>
    );
  };

  renderMenu = () => {
    if (this.state.isMenuOpen) {
      return <Menu {...this.props} />;
    }
  };

  toggleLanguagePanel = () => {
    HeaderActions.toggleSlidingPanel();
  };

  renderLanguageMenu = () => {
    if (this.props.language.languages.length < 2) {
      return false;
    }

    const activeLanguage = this.props.language.languages.filter((lang) => {
      if (lang.shortDisplayName === this.props.language.currentLanguage.shortDisplayName) {
        return lang;
      }
    });
    const currentLanguageName = activeLanguage[0] ? activeLanguage[0].fullDisplayName : '';
    const selectLanguage = translate('languageModule', 'LANGUAGE');

    const languageList = (
      <CollapsibleList
        title={selectLanguage}
        activeLanguage={currentLanguageName}
        open
        persistState
        persistantStateId={`jsEx-mobile`}
      >
        <ul className="languageList">
          {this.props.language.languages.map((lang, idx) => {
            const itemClass = lang.shortDisplayName !== this.props.language.currentLanguage.shortDisplayName
              ? 'languageList-item'
              : 'languageList-item languageList-item--active';
            return (
              <li className={itemClass} key={idx}>
                <a
                  href={lang.link}
                  data-component="languageItemLink"
                  aria-label={lang.fullDisplayName}
                >
                  {lang.fullDisplayName}
                  <span />
                </a>
              </li>
            );
          })}
        </ul>
      </CollapsibleList>
    );

    return (
      <div>
        <MenuItem
          type="language"
          title={this.props.language.currentLanguage.shortDisplayName}
          isActive={this.state.language}
          onClick={this.toggleLanguagePanel} />
        <SlidingPanel children={languageList} />
      </div>

    );
  };

  render () {
    return (
      <div className="header__mobile" data-component="mobileHeader">
        {this.renderLanguageMenu()}
        <div className="mobilemenu">
          {this.renderMenuButton()}
          <Logo {...this.props.logo} />
        </div>
        {this.renderMenu()}

        <SearchDiscover {...this.props} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/mobile/index.js